import { useContext } from "react";
import { VoiceContext, VoiceContextValue } from "./voiceContext";

export function useVoice(): VoiceContextValue {
  const ctx = useContext(VoiceContext);
  if (!ctx) throw new Error("useVoice must be used inside <VoiceProvider>");
  return ctx;
}
